import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setView } from '../../modules/explorer';
import styles from './PreviewMaterial.module.css';
import propTypes from 'prop-types';
import { getModel, getModelPreview } from '../../modules/models';
import RenderReview from '../../components/RenderReview';
import { getMaterial, getMaterialPreview } from '../../modules/materials';
import Divider from '../../components/Divider';
import Button from '../../components/Button';
import { createJob } from '../../modules/jobs';

const diffuseTpl = {
  '156':
    'https://s3.ca-central-1.amazonaws.com/exocortex-crateandbarrel/2k/481_10/Bloomfield+Bluebell-diffuse21x24.2K.jpg',
  '166':
    'https://s3.ca-central-1.amazonaws.com/exocortex-crateandbarrel/Karma+Mardi+Gras-diffuse45.5x34.5.2k.png',
  '157':
    'https://s3.ca-central-1.amazonaws.com/exocortex-crateandbarrel/Bloomfield+Granite-diffuse21x24.2K.jpg',
};

const swatches = {
  '156':
    'https://s3.ca-central-1.amazonaws.com/exocortex-crateandbarrel/choice_156.jpg',
  '157':
    'https://s3.ca-central-1.amazonaws.com/exocortex-crateandbarrel/choice_157.jpg',
  '166':
    'https://s3.ca-central-1.amazonaws.com/exocortex-crateandbarrel/choice_166_KarmaMardiGras3DS17.jpg',
};

class PreviewMaterial extends Component {
  state = {};

  static contextTypes = {
    router: propTypes.object,
  };

  async componentDidMount() {
    const {
      catogary,
      setView,
      getModel,
      getMaterial,
      getModelPreview,
      getMaterialPreview,
    } = this.props;
    const { router } = this.context;
    const { id } = router.route.match.params;
    let model = null;
    if (catogary === 'models') {
      model = await getModel(id);
      await getModelPreview(id);
    } else if (catogary === 'materials') {
      model = await getMaterial(id);
      await getMaterialPreview(id);
    }
    this.setState({ model });
    setView({ page: 'viewpage', catogary, activeLabel: 'preview' });
  }

  componentWillUnmount() {
    const { setView } = this.props;
    setView(null);
  }
  renderPreview = async () => {
    const { router } = this.context;
    const { id } = router.route.match.params;
    const { createJob, catogary } = this.props;
    const previewAttr = {
      type:
        catogary === 'models'
          ? 'modelPreview'
          : catogary === 'materials'
            ? 'materialPreview'
            : '',
      modelId: id,
    };
    await createJob(previewAttr);
    router.history.push(`/${catogary}/${id}`);
  };

  render() {
    const { catogary } =this.props;
    const { model } = this.state;
    if (!model) return null;
    const preview = model.preview;
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          {model.friendlyName || 'Untitled Model'} Render Preview
        </div>
        <Divider />
        <div className={styles.content}>
          <div className={styles.headerContainer}>
            <div className={styles.renderNotes}>
              {catogary[0].toUpperCase() + catogary.replace(/m|s/g, '')} rendered:
              <span className={styles.renderMtls}> {model.friendlyName}</span>
            </div>
            <Button text="Render Preview" onClick={this.renderPreview} />
          </div>
          {preview &&
            preview.results.map(url => {
              const title = url.split('/').pop();
              const result = url;
              const materialCode = title
                .replace(/_0|.png/g, '')
                .split('_')
                .pop();
              const swatch = swatches[materialCode];
              const diffuse = diffuseTpl[materialCode];
              return (
                <RenderReview output={{ title, result, swatch, diffuse }} />
              );
            })}
        </div>
      </div>
    );
  }
}

const previewPage = catogary =>
  connect(
    state => ({
      catogary,
    }),
    {
      setView,
      getModel,
      getMaterial,
      getModelPreview,
      createJob,
      getMaterialPreview,
    }
  )(PreviewMaterial);

export default previewPage;



// WEBPACK FOOTER //
// ./src/containers/PreviewMaterial/index.js